import type { IDocumentBackPopupProps } from "../../types";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";

export default function DocumentBackPopup(props: IDocumentBackPopupProps) {
  const { text, askDocumentBack, isDocumentBack, styles, handleNoDocumentBack, handleDocumentBack } = props;

  return (
    <Dialog open={askDocumentBack && isDocumentBack === null}>
      <DialogTitle>{text.isDocBack}</DialogTitle>

      <DialogActions sx={{ justifyContent: "space-around" }}>
        <Button onClick={handleNoDocumentBack} sx={styles.continue}>
          {text.no}
        </Button>

        <Button onClick={handleDocumentBack} sx={styles.continue}>
          {text.yes}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
